import { type TranslationMessages } from 'react-admin'
import jaMessages from '@bicstone/ra-language-japanese'

export const ja: TranslationMessages = {
  ...jaMessages,
  resources: {
    contact: {
      title: 'お問い合わせ内容入力',
      show: {},
      fields: {
        inquiryItems: 'f',
        partner: '保証会社',
        organization: '不動産管理会社',
        product: '商品',
        issueKey: 'OPS番号',
        entryDate: '入居日',
        address: '住所',
        place: '物件名',
        placeNumber: '部屋番号',
        attributeNumber: '個社ID',
        assigneeName: '担当者名',
        assigneeEmail: '担当者メールアドレス',
        issueStatus: 'ステータス',
        contactDate: '問い合わせ日',
        responseDate: '回答日',
        'inquiryItems.mainCategory': '問合せ区分',
        'inquiryItems.subCategory': '中区分',
        'inquiryItems.detail': '小区分',
        'inquiryItems.note': '詳細',
        'inquiryItems.response': 'ご回答'
      },
      button: {
        submit: '送信'
      },
      notify: {
        submit: {
          success: '送信に成功しました',
          error: '送信に失敗しました'
        },
        file: {
          success: 'ファイルの送信に失敗しました',
          error: 'ファイルの送信に失敗しました'
        }
      }
    },
    response: {
      title: 'ご回答フォーム'
    }
  },
  ra: {
    ...jaMessages.ra,
    auth: {
      ...jaMessages.ra.auth,
      require_new_password: '新しいパスワードを設定してください',
      username: 'アカウント(メールアドレス)',
      password: 'パスワード',
      confirm_password: 'パスワード(確認用)',
      sign_in: 'ログイン',
      sign_in_error: 'ログインエラー',
      auth_check_error: 'メールアドレスまたはパスワードが違います',
      forgot_password: 'パスワードをお忘れ/ご変更の方はこちらから',
      exec_forgot_password: '新しいパスワードの設定',
      require_verification_code: 'メールに届いた確認コードを入力してください',
      verification_code: '確認コード',
      send_verification_code: '確認コードを送信',
      session_expire: '再度ログインしてください'
    },
    validation: {
      ...jaMessages.ra.validation,
      do_not_match: 'パスワードが一致しません'
    }
  },
  required: '入力してください',
  'too small': '文字数が不足しています',
  'too large': '文字数が多すぎます',
  'Expected string, received null': '入力必須です',
  'cannot download summary': '取得できません',
  'invalid syntax': '不正な形式です',
  'uploading pdf': 'PDFファイルを送信中',
  'cannot upload pdf': 'PDFファイルを送信できません',
  'downloading pdf': 'PDFファイルを取得中',
  'cannot download pdf': 'PDFファイルを取得できません',
  retrying: '同意申込を再実行中',
  'failed retry': '同意申込の再実行を完了できません'
}
